// components/notifications/NotificationBadge.tsx
import React from 'react';
import { useNotifications } from './NotificationContext';

interface NotificationBadgeProps {
    className?: string;
}

export const NotificationBadge: React.FC<NotificationBadgeProps> = ({
    className = ''
}) => {
    const { unreadCount } = useNotifications();

    if (unreadCount === 0) {
        return null;
    }

    return (
        <div className={`inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full ${className}`}>
            {unreadCount > 99 ? '99+' : unreadCount}
        </div>
    );
};
